import HttpApi from '@/utils/HttpApi'

export default class QueryApi {
    public static async executeQuery(query: string) {
        const params = {
            query,
        }
        const response = await HttpApi.put<QueryResultEntity>('query', params)

        return response
    }

    public static async saveQuery(name: string, description: string, query: string) {
        const params = {
            name,
            description,
            query,
        }
        const response = await HttpApi.post<SavedQueryEntity>('query', params)

        return response
    }

    public static async getQueries(search?: string) {
        const params = search ? { search } : {}
        const response = await HttpApi.get<SavedQueriesEntity>('query', params)

        return response
    }
}
